import MicroModal from "micromodal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { differenceInSeconds, format } from "date-fns";
import axios from "axios";

import { Tooltippy, PopoverDashboard } from "../../actions/Tippy";
import Typography from "../Typography";
import Table from "../table";
import TimeCounterInternalDash from "../../containers/TimeCounterInternalDash";
import TimeCounterMinute from "../../containers/TimeCounterMinute";

import {
  GetInteractionsModal,
  GetHistory,
  DetailsAnotationsida,
  DetailsFileShared,
  DetailsMarkstarida,
  InteracoesContactNumber,
  InterationNotifier,
  SolicitarChamada,
  ShowInfoDisplay,
  ActionRefreshNoAnswer,
  deleteListCallQueue,
  ActionDeleteCall,
} from "../../actions";
import { RefreshNoAnswerCall } from "../../actions/websocket";
import { connection_platform } from "../../services/api";

import "../../build/css/modal.css";
import "./modals.css";

import { ReactComponent as MoreIcon } from "../../build/images/moreinfo.svg";
import { ReactComponent as TRANSFERICON2 } from "../../build/images/icons/transfer-client-icon2.svg";
import { ReactComponent as ENCERRARATENDIMENTO } from "../../build/images/icons/byeatendant-client-icon.svg";
import { ReactComponent as EmptyState } from "../../build/images/emptystatemanagerhorizontal.svg";
import { ReactComponent as HappyRating } from "../../build/images/icons-rating/happy.svg";
import { ReactComponent as IndifRating } from "../../build/images/icons-rating/indifferent.svg";
import { ReactComponent as SadRating } from "../../build/images/icons-rating/sad.svg";
import { ReactComponent as NullRating } from "../../build/images/icons-rating/star-slash.svg";
import { ReactComponent as Anotacoes } from "../../build/images/popover-queue/edit-2.svg";
import { ReactComponent as ArquivosComp } from "../../build/images/popover-queue/direct-send.svg";
import { ReactComponent as MsgFavoritas } from "../../build/images/popover-queue/sms-star.svg";
import { ReactComponent as Interacoes } from "../../build/images/popover-queue/people.svg";
import { ReactComponent as Call } from "../../build/images/teams/call.svg";
import { ReactComponent as Transferir } from "../../build/images/popover-queue/redo.svg";
import { ReactComponent as WhatsappIcon } from "../../build/images/icons-channels/whatsapp-large.svg";
import { ReactComponent as FacebookIcon } from "../../build/images/icons-channels/facebook.svg";
import { ReactComponent as VozIcon } from "../../build/images/icons-channels/voz-large.svg";
import { ReactComponent as EmailIcon } from "../../build/images/icons-channels/email.svg";
import { ReactComponent as WebchatIcon } from "../../build/images/icons-channels/webchat-large.svg";
import { ReactComponent as TelegramIcon } from "../../build/images/icons-channels/telegram-large.svg";
import { ReactComponent as GOOGLEGBM } from "../../build/images/icons-channels/googlegbm-large.svg";
import { ReactComponent as InstaIcon } from "../../build/images/icons-channels/instagram-large.svg";
import { ReactComponent as TEAMS } from "../../build/images/channelsNew/teamsBig.svg";

function defaultSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data.toLowerCase();
  const objectRowB = rowB.original[columnId].data.toLowerCase();

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function defaultNumberSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data;
  const objectRowB = rowB.original[columnId].data;

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function dateTimeSorting(rowA, rowB, columnId) {
  const dateRowA = rowA.original[columnId].config.customOrder;
  const dateRowB = rowB.original[columnId].config.customOrder;

  if (dateRowA > dateRowB) return -1;
  if (dateRowB > dateRowA) return 1;
  return 0;
}

function customSorting(rowA, rowB, columnId) {
  const customRowA = rowA.original[columnId].config.customOrder;
  const customRowB = rowB.original[columnId].config.customOrder;

  if (customRowA > customRowB) return -1;
  if (customRowB > customRowA) return 1;
  return 0;
}

var port = localStorage.getItem("port");
var pathname = localStorage.getItem("pathname");

export default function SeeQueue({ queue, setQueue, setInfoQueue, setDelete }) {
  const [dataTable, setDataTable] = useState([]);

  const InfoUsers = useSelector((state) => state.informationusers);
  const listCallQueue = useSelector((state) => state.listcallqueue);
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const callpark = useSelector((state) => state.callpark);
  const StatusAgent = useSelector((state) => state.status);

  const dispatch = useDispatch();

  const sortBy = {
    sortBy: [
      {
        id: "start",
        desc: false,
      },
    ],
  };

  let columns = [
    {
      Header: "Satisfação",
      accessor: "satisfaction",
      Hint: "Início",
      id: "satisfaction",
      sortType: customSorting,
      disableFilters: true,
      display: true,
      // display: chooseDisplay("Início"),
    },
    {
      Header: "Canal",
      accessor: "channel",
      Hint: "Canal",
      id: "channel",
      disableFilters: true,
      sortType: customSorting,
      display: true,
      // display: chooseDisplay("Número"),
      // disableSortBy: true,
    },
    {
      Header: "Telefone",
      accessor: "number",
      Hint: "Telefone",
      id: "number",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
      // display: chooseDisplay("CDR"),
    },
    {
      Header: "Grupo",
      accessor: "group",
      Hint: "Grupo",
      id: "group",
      disableFilters: true,
      sortType: customSorting,
      display: true,
      // display: chooseDisplay("Última Mensagem Cliente"),
    },
    {
      Header: "Data e hora",
      accessor: "timeTotal",
      Hint: "Data e hora",
      id: "timeTotal",
      disableFilters: true,
      sortType: dateTimeSorting,
      display: true,
      // display: chooseDisplay("Última Mensagem Agente"),
    },
    {
      Header: "Tempo",
      accessor: "time",
      Hint: "Tempo",
      id: "time",
      disableFilters: true,
      sortType: dateTimeSorting,
      display: true,
      // display: chooseDisplay("Cliente em espera"),
    },
    {
      Header: "Qtd. de tentativas",
      accessor: "attempts",
      Hint: "Qtd. de tentativas",
      id: "attempts",
      disableFilters: true,
      sortType: defaultNumberSorting,
      display: true,
      // display: chooseDisplay("Agente em espera"),
    },
    {
      Header: "Qtd. de retornos",
      accessor: "returns",
      Hint: "Qtd. de retornos",
      id: "returns",
      disableFilters: true,
      sortType: defaultNumberSorting,
      display: true,
    },
    {
      Header: "Ações",
      accessor: "actions",
      Hint: "Ações",
      id: "actions",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
      disableSortBy: true,
    },
  ];

  function formatTime(segundos) {
    var horas = Math.floor(segundos / 3600);
    var minutos = Math.floor((segundos % 3600) / 60);
    var segundos = segundos % 60;

    return (
      horas.toString().padStart(2, "0") +
      ":" +
      minutos.toString().padStart(2, "0") +
      ":" +
      segundos.toString().padStart(2, "0")
    );
  }

  const calculateTime = (date, type) => {
    let duracao = 0;
    let days = 0;
    let arrayCompA = date;
    let datatimeCompA = moment().format("YYYY/MM/DD HH:mm:ss");
    let dataStatusA = moment(arrayCompA, "DD/MM/YYYY HH:mm:ss").format(
      "YYYY/MM/DD HH:mm:ss"
    );

    var valorDiferenca = parseInt(
      Math.abs(Math.round(LoginCompleteReducer.difftime))
    );

    if (parseInt(LoginCompleteReducer.difftime) < 0) {
      datatimeCompA = moment()
        .subtract(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    } else {
      datatimeCompA = moment()
        .add(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    }

    duracao = moment(datatimeCompA).diff(dataStatusA, "seconds");
    duracao = duracao < 0 ? 0 : duracao;
    return duracao;
  };

  const convertDays = (totalSeconds) => {
    const secondsInDay = 86400;
    const days = Math.floor(totalSeconds / secondsInDay);

    return days;
  };

  const changeDisplayTransfer = (e, cdrid, scriptid, mediaid, queueId) => {
    // document.getElementById("transfer_teste").click();
    setInfoQueue({
      cdrid: cdrid,
      scriptid: scriptid,
      mediaid: mediaid,
      queueId: queueId,
    });
  };

  const showModals = (
    e,
    numberqueue,
    contactname,
    modal,
    cdrid,
    queueid,
    queue
  ) => {
    dispatch(GetInteractionsModal(contactname, numberqueue));

    switch (modal) {
      case "modal__anotacoes":
        buttonSearchAnotation(e, numberqueue);
        MicroModal.show("modal__anotacoes-details-new");
        break;
      case "modal__arquivos-compartilhados":
        buttonSearchFileCompart(e, numberqueue);
        MicroModal.show("modal__arquivos-compartilhados-details");
        break;
      case "modal__mensagens-favoritas":
        buttonSearchMarkstar(e, numberqueue);
        MicroModal.show("modal__mensagens-favoritas-details");
        break;
      case "modal__historico-atendimento-queue":
        dispatch(GetHistory([]));
        const agora = moment().subtract(7, "days");
        let histstart = agora.format("YYYY-MM-DDT00:00");
        let histend = moment().format("YYYY-MM-DDT23:59");

        displayHistoric(numberqueue);
        MicroModal.show("modal__historico-atendimento-details");
        break;
      case "modal__excluir":
        // MicroModal.show("modal__excluir");
        PropsRefreshNoAnswer(cdrid, queueid, InfoUsers, queue);

        // setDelete({
        //   deletequeueid: cdrid,
        //   deletecdrid: queueid,
        //   mediaid: queue.mediaid,
        // });
        break;
      default:
        break;
    }
  };

  function buttonSearchAnotation(e, telefone) {
    var erro = 0;
    let now = moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = moment().format("YYYY-MM-DD");
    const idcriticidade = "";

    let comparation = moment(datainit).isBefore(datafim);

    if (datainit == "") erro = 1;

    if (datafim == "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(
        DetailsAnotationsida(datainit, datafim, idcriticidade, telefone)
      );
    }
  }

  function buttonSearchFileCompart(e, telefone) {
    var erro = 0;
    let now = moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = moment().format("YYYY-MM-DD");
    const formats =
      "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28";
    const midias = "2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18";

    var comparation = moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (formats == "") var erro = 1;

    if (midias == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(DetailsFileShared(datainit, datafim, formats, midias, telefone));
    }
  }

  function buttonSearchMarkstar(e, telefone) {
    var erro = 0;
    let now = moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = moment().format("YYYY-MM-DD");

    var comparation = moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(DetailsMarkstarida(datainit, datafim, telefone));
    }
  }

  function displayHistoric(telefone, cdrid) {
    let now = moment().subtract(7, "days");
    const datainit = now.format("YYYY-MM-DD") + "T00:00";
    const datafim = moment().format("YYYY-MM-DD") + "T23:59";
    let idgroup = InfoUsers.idgroup;
    dispatch(
      InteracoesContactNumber(
        telefone.substr(2),
        datainit,
        datafim,
        "",
        idgroup
      )
    );
  }

  function SolicitaChamada(
    InfoUsers,
    scriptid,
    cdrid,
    mediaid,
    status,
    StatusAgent
  ) {
    if (StatusAgent.allowCapture === false) {
      dispatch(InterationNotifier("Pausa não permite captura", "permission"));
    } else {
      dispatch(SolicitarChamada(InfoUsers, scriptid, cdrid, mediaid));
    }
  }

  function PropsRefreshNoAnswer(cdrid, queueid, infousers, queue) {
    dispatch(ActionRefreshNoAnswer(queueid));
    RefreshNoAnswerCall(cdrid, queueid, infousers, queue);
    // dispatch(deleteListCallQueue(queueid));
    // dispatch(
    //   ActionDeleteCall(
    //     queueid,
    //     "Exclusão da Fila pelo Dashboard",
    //     infousers.id,
    //     false,
    //     queue.mediaid
    //   )
    // );
  }

  const renderTableOptions = (queue) => {
    return (
      <ul className="context-menu__list modals">
        <li
          className="contact-info contact-info--with-action callAction"
          onClick={
            callpark === true
              ? (event) => {
                  SolicitaChamada(
                    InfoUsers,
                    queue.scriptid,
                    queue.cdrid,
                    queue.mediaid,
                    StatusAgent.status,
                    StatusAgent
                  );
                  dispatch(ShowInfoDisplay("Clientes"));
                }
              : () => {}
          }
        >
          <Call />
          <div className="contact-info__name">Atender</div>
        </li>
        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            showModals(
              event,
              queue.caller,
              queue.contactname,
              "modal__historico-atendimento-queue",
              queue.cdrid,
              queue.queueid,
              queue
            )
          }
        >
          <Interacoes />
          <div className="contact-info__name">Interações</div>
        </li>
        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            showModals(
              event,
              queue.caller,
              queue.contactname,
              "modal__anotacoes",
              queue.cdrid,
              queue.queueid,
              queue
            )
          }
        >
          <Anotacoes />
          <div className="contact-info__name">Anotações</div>
        </li>
        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            showModals(
              event,
              queue.caller,
              queue.contactname,
              "modal__mensagens-favoritas",
              queue.cdrid,
              queue.queueid,
              queue
            )
          }
        >
          <MsgFavoritas />
          <div className="contact-info__name">Mensagens favoritas</div>
        </li>
        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            showModals(
              event,
              queue.caller,
              queue.contactname,
              "modal__arquivos-compartilhados",
              queue.cdrid,
              queue.queueid,
              queue
            )
          }
        >
          <ArquivosComp />
          <div className="contact-info__name">Arquivos compartilhados</div>
        </li>
        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            changeDisplayTransfer(
              event,
              queue.cdrid,
              queue.scriptid,
              queue.mediaid,
              queue.queueid
            )
          }
        >
          <Transferir />
          <div className="contact-info__name">Transferir</div>
        </li>

        <li
          className="contact-info contact-info--with-action endAction"
          onClick={(event) =>
            showModals(
              event,
              queue.caller,
              queue.contactname,
              "modal__excluir",
              queue.cdrid,
              queue.queueid,
              queue
            )
          }
        >
          <ENCERRARATENDIMENTO />
          <div className="contact-info__name">Encerrar atendimento</div>
        </li>
      </ul>
    );
  };

  const renderAvaliation = (queue) => {
    switch (queue.score_class) {
      case "otimo":
      case "promotor":
        return (
          <Tooltippy
            content={`Cliente satisfeito - ${queue.score_value}`}
            placement="top"
          >
            <div className="user-rating__tag happy">
              <HappyRating />
            </div>
          </Tooltippy>
        );

      case "razoavel":
      case "neutro":
        return (
          <Tooltippy
            content={`Cliente indiferente - ${queue.score_value}`}
            placement="top"
          >
            <div className="user-rating__tag indifferent">
              <IndifRating />
            </div>
          </Tooltippy>
        );

      case "ruim":
      case "detrator":
        return (
          <Tooltippy
            content={`Cliente insatisfeito - ${queue.score_value}`}
            placement="top"
          >
            <div className="user-rating__tag sad">
              <SadRating />
            </div>
          </Tooltippy>
        );

      default:
        return (
          <Tooltippy content={`Nenhuma avaliação`} placement="top">
            <div className="user-rating__tag">
              <NullRating />
            </div>
          </Tooltippy>
        );
    }
  };

  const renderChannel = (media) => {
    let channelIcon = "";
    let channelName = "";
    if (media === 5) {
      channelIcon = <WhatsappIcon />;
      channelName = "Whatsapp";
    }
    if (media === 4) {
      channelIcon = <FacebookIcon />;
      channelName = "Facebook";
    }
    if (media === 3) {
      channelIcon = <EmailIcon width="32" height="32" />;
      channelName = "Email";
    }
    if (media === 1) {
      channelIcon = <VozIcon />;
      channelName = "Telefone";
    }
    if (media === 6) {
      channelIcon = <InstaIcon />;
      channelName = "Instagram";
    }
    if (media === 8) {
      channelIcon = <TelegramIcon />;
      channelName = "Telegram";
    }
    if (media === 2) {
      channelIcon = <WebchatIcon />;
      channelName = "Webchat";
    }
    if (media === 11) {
      channelIcon = <GOOGLEGBM />;
      channelName = "Google GBM";
    }
    if (media === 15) {
      channelIcon = <TEAMS />;
      channelName = "Teams";
    }

    return (
      <Tooltippy content={channelName} placement="top">
        {channelIcon}
      </Tooltippy>
    );
  };

  const closeModal = (modal) => {
    MicroModal.close(modal);
    setQueue(false);
  };

  useEffect(() => {
    if (queue) {
      let listCall = [];
      let subServices = JSON.parse(queue.idsubservico);
      let servicesChange = subServices.map((sub) => sub.id_resposta);

      listCall.push(...servicesChange);

      let listRowQueue = listCallQueue.filter(
        (call) => parseInt(call.status) === 1
      );

      const listQueue = listRowQueue.filter((call) =>
        listCall.includes(call.serviceinid)
      );

      const formatData = listQueue.map((datum) => {
        let timeDuration = calculateTime(datum.to_char);
        let timeAgent = differenceInSeconds(
          new Date(),
          new Date(datum.ultima_msg_agente)
        );
        let days = convertDays(timeDuration);

        return {
          satisfaction: {
            data: (
              <span className="manager-box-status__text more-width">
                {renderAvaliation(datum)}
              </span>
            ),
            config: {
              textEllipsis: true,
              className: "cell-blue-text",
              customOrder: datum.score_value,
            },
          },
          channel: {
            data: renderChannel(datum.mediaid),
            config: {
              textEllipsis: true,
              customOrder: datum.mediaid,
            },
          },
          number: {
            data: datum.caller,
            config: {
              textEllipsis: true,
            },
          },
          group: {
            data: (
              <Tooltippy content={datum.called} placement="top">
                <span className="manager-box-status__text more-width">
                  {datum.called}
                </span>
              </Tooltippy>
            ),
            config: {
              textEllipsis: true,
              className: "cell-blue-text",
              customOrder: datum.called,
            },
          },
          timeTotal: {
            data: datum.to_char,
            config: {
              textEllipsis: true,
              customOrder: new Date(
                moment(datum.to_char, "DD/MM/YYYY HH:mm:ss").format(
                  "YYYY/MM/DD HH:mm:ss"
                )
              ),
            },
          },
          time: {
            data: (
              // <TimeCounterInternalDash
              //   horario={parseInt(timeDuration)}
              //   key={timeDuration}
              // />
              <TimeCounterMinute
                horario={parseInt(timeDuration)}
                day={days}
                key={timeDuration}
              />
            ),
            config: {
              customOrder: new Date(
                moment(datum.to_char, "DD/MM/YYYY HH:mm:ss").format(
                  "YYYY/MM/DD HH:mm:ss"
                )
              ).getTime(),
              className: "cell-gray-text",
            },
          },
          attempts: {
            data: datum.recv_count,
            config: {
              textEllipsis: true,
            },
          },
          returns: {
            data: datum.callback_count,
            config: {
              customOrder: timeAgent,
              className: "",
            },
          },
          actions: {
            data: (
              <PopoverDashboard
                trigger="click"
                boundary="window"
                placement="top"
                multiple={true}
                interactive={true}
                content={renderTableOptions(datum)}
              >
                <MoreIcon style={{ cursor: "pointer" }} />
              </PopoverDashboard>
            ),
            config: {
              className: "",
            },
          },
        };
      });

      setDataTable(formatData);
    } else {
      setDataTable([]);
    }
  }, [queue, listCallQueue]);

  return (
    <>
      <div
        className="modal micromodal-slide"
        id="modal__seeQueues"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__queues__title"
          >
            <div className="modal__see-queues_header">
              <span className="modal__see-queues-title">
                Grupo de Fila - {queue.nomegrupofila}
              </span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  closeModal("modal__seeQueues");
                }}
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
              ></button>
            </div>
            <div className="modal__see-queues_body">
              <div className="modal__see-queues_body-container">
                <div className="modal__see-queues_body-table">
                  {dataTable.length > 0 ? (
                    <Table
                      className="table-email"
                      data={dataTable}
                      columns={columns}
                      fixedHeader
                      screen="manager"
                      // fixedFirstColumn
                      // filtersActive={filtersActive}
                      // emptyState={emptyState}
                      // setEmptyState={setEmptyState}
                      initialState={sortBy}
                      rowShadowLine
                    />
                  ) : (
                    <EmptyState />
                  )}
                </div>
                <Typography.H6 color={"gray-200"}>
                  {dataTable.length} Resultado(s)
                </Typography.H6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
